@if (story()) {
  @if (story().content.component === 'root') {
    @if (!hideHeader()) {
      <app-website-header
        [startTheme]="navTheme()"
        [pageTheme]="story().content.theme === 'dark' ? 'dark' : 'light'"
        [hideNav]="!story().content.showNavigation || hideHeaderNav()"
        [overlay]="!!overlayNav()"
        [customCta]="customCta()"
      ></app-website-header>
    }
    @defer (hydrate on idle) {
      <main
        [appStoryblok]="story().content._editable"
        class="storyblok-page"
        [class.theme-dark]="pageTheme() === 'dark'"
        [class.theme-light]="pageTheme() === 'light'"
        [class.transparent-surfaces]="transparentSurfaces()"
        [class.bg-base]="!transparentSurfaces() && pageStyle() === 'base'"
        [class.bg-base-subdued]="!transparentSurfaces() && pageStyle() === 'base-subdued'"
        [class.bg-base-strong]="!transparentSurfaces() && pageStyle() === 'base-strong'"
      >
        @for (blok of story().content['body']; track blok._uid; let blokIndex = $index) {
          <!-- First bloks hydrate with the page (on idle, via the parent block); everything below
               the fold stays dehydrated SSR HTML until scrolled near. `on idle` is the regular
               trigger for client-side navigations, where hydrate triggers don't apply. -->
          @if (blokIndex < 2) {
            <ndc-dynamic
              [ndcDynamicComponent]="$any(components[blok.component])"
              [ndcDynamicInputs]="dynamicInputs(blok)"
            ></ndc-dynamic>
          } @else {
            @defer (on idle; hydrate on viewport) {
              <ndc-dynamic
                [ndcDynamicComponent]="$any(components[blok.component])"
                [ndcDynamicInputs]="dynamicInputs(blok)"
              ></ndc-dynamic>
            }
          }
        }
      </main>
      @if (prefooter()) {
        <app-pre-footer
          [dark]="preFooterIsDark()"
          [style]="pageStyle()"
          [lightImage]="prefooter().image?.filename | storyblokCdn"
          [darkImage]="prefooter().image?.filename | storyblokCdn"
          [appStoryblok]="prefooter()._editable"
        >
          <a
            [routerLink]="['/auth/signup']"
            appButton
            name="signup-cta"
            location="pre-footer"
            color="primary"
            height="4"
            spacing="4"
            size="3"
            weight="default"
            shape="round"
            [center]="true"
          >
            <b>{{ 'Try Picflow for Free' | translate: 'storyblok.pre-footer-cta' }}</b>
          </a>
        </app-pre-footer>
      }
      @if (!hideFooter()) {
        <!-- Always below the fold; hydrate only when scrolled near. -->
        @defer (on idle; hydrate on viewport) {
          <app-website-footer
            [simpleMode]="!story().content.showNavigation"
            [dark]="footerIsDark()"
          ></app-website-footer>
        }
      }
    }
  } @else {
    <ndc-dynamic
      [ndcDynamicComponent]="$any(components[story().content.component])"
      [ndcDynamicInputs]="story().content"
    ></ndc-dynamic>
  }
}
@defer (when !story()) {
  @if (!story()) {
    <app-website-header></app-website-header>
    <app-not-found bgChars="404" [errorTitle]="'Not Found' | translate: 'storyblok.not-found'">
      {{
        'Whoops! It looks like this page does not exist anymore. Try going back to our homepage.'
          | translate: 'storyblok.not-found-description'
      }}
      <a
        [routerLink]="['/'] | translateLink"
        appButton
        name="home"
        location="404-page"
        color="primary"
        spacing="4"
        shape="round"
        height="3"
        [center]="true"
        >{{ 'Back to Home' | translate: 'storyblok.back-to-home' }}</a
      >
    </app-not-found>
    <app-website-footer></app-website-footer>
  }
} @error {
  <div>
    {{
      'Whoops! It looks like this page does not exist anymore. Try going back to our homepage.'
        | translate: 'storyblok.not-found-description'
    }}
  </div>
}
<!-- This is a hack to force the translation system to load. Without this, the pre-footer doesn't contain any translations in the SSR render-->
{{ '' | translate: 'storyblok.empty' }}
